import { RankingBarChart } from './RankingBarChart';
import type { NameValueItem } from './types';

type ExtortedApplicationsAmountChartProps = {
  data: NameValueItem[];
  loading?: boolean;
  title?: string;
};

const formatCurrency = (value: number) => `S/ ${new Intl.NumberFormat('en-US').format(value)}`;

export const ExtortedApplicationsAmountChart = ({
  data,
  loading = false,
  title = 'MONTO EXTORNADO POR CONVENIO',
}: ExtortedApplicationsAmountChartProps) => (
  <RankingBarChart
    title={title}
    data={data}
    loading={loading}
    formatValue={formatCurrency}
    valueColor="#12b5c9"
  />
);
